import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Panel } from '../../../../common/panel'
import { Table } from '../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../routers/constants'
import { PORTFOLIOS_COL } from '../constant'
import {
  changeSettingOther,
  selectOtherSetting,
  selectPortfolioById,
} from '../store/slice'

export const PortfolioList = () => {
  const dispatch = useDispatch()

  const profilePortfolios = useSelector(selectOtherSetting('portfolios')) || []

  const removePortfolio = (portfolioId) => {
    const newList = profilePortfolios.filter(
      (i) => i.portfolioId !== portfolioId,
    )
    dispatch(changeSettingOther({ portfolios: newList }))
  }

  if (!profilePortfolios.length) return null

  return (
    <Element style={{ margin: '0 -6px' }}>
      <Panel label="alertSetting.PORTFOLIOS" isI18n>
        <Element style={{ backgroundColor: '#FFFFFF' }}>
          <Table
            ids={profilePortfolios.map((i) => i.portfolioId)}
            getDataFromRedux={selectPortfolioById}
            schema={Object.keys(PORTFOLIOS_COL).map((key) => {
              const title = `alertSetting.${key}`
              const colId = PORTFOLIOS_COL[key]
              const thStyle = {
                margin: [PORTFOLIOS_COL.DELETE].includes(colId) ? 'auto' : '',
              }
              const tdStyle = {
                width: colId === PORTFOLIOS_COL.DELETE ? '13.4%' : '',
              }

              return {
                colId,
                title,
                isI18n: true,
                thStyle,
                tdStyle,
                renderTh: (title) => {
                  switch (colId) {
                    case PORTFOLIOS_COL.DELETE:
                      return ''
                    default:
                      return title
                  }
                },
                render: (data, { rowId }) => {
                  switch (colId) {
                    case PORTFOLIOS_COL.DELETE:
                      return (
                        <Icon
                          className="icon-trash-fill"
                          style={{ fontSize: 12, color: '#9C9C9C' }}
                          onClick={() => removePortfolio(rowId)}
                        />
                      )
                    default:
                      return (
                        <Element
                          className="breakWordAll cursorPointer"
                          style={{ color: '#2C73E8' }}
                        >
                          <Link
                            to={`${COMPONENTS.library.components.savedPortfolios.components.detailsPortfolio.route}?id=${rowId}`}
                            target="_blank"
                          >
                            <TextEllipsisStaticLine
                              text={data}
                              isI18n={false}
                              tooltipMaxWidthByContent
                              zIndexTooltip={14}
                            />
                          </Link>
                        </Element>
                      )
                  }
                },
              }
            })}
            autoHeightMax={210}
          />
        </Element>
      </Panel>
    </Element>
  )
}
